import { appConstants } from "../constants/appConstants"

const initialState = { toast: false }

const toastReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case appConstants.UPDATE_TOAST_TRUE:
      return {
        toastMessage: {
          text: action.payload.text,
          type: action.payload.type,
        },
      }
    case appConstants.UPDATE_TOAST_FALSE:
      return { toastMessage: false }
    case appConstants.RESET:
      return { ...initialState }
    default:
      return state
  }
}

export default toastReducer
